import { render } from "./GroupCategoryAttendance.vue?vue&type=template&id=8b0b81f0&scoped=true"
import script from "./GroupCategoryAttendance.vue?vue&type=script&lang=js"
export * from "./GroupCategoryAttendance.vue?vue&type=script&lang=js"

import "./GroupCategoryAttendance.vue?vue&type=style&index=0&id=8b0b81f0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0b81f0"]])

export default __exports__